import { render, staticRenderFns } from "./TraceDetail.vue?vue&type=template&id=182d1b7a&"
import script from "./TraceDetail.vue?vue&type=script&lang=js&"
export * from "./TraceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports